import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackDeselectedItems } from "@air/analytics";
import { resetSelectedItemsAction, selectedItemsSelector } from "@air/redux-selected-items";
import { memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SelectionActionBarComponent } from "~/components/v2/components/shared/selectionBar/SelectionActionBarComponent";
export const BoardsAndAssetsSelectionBar = /*#__PURE__*/ memo((param)=>{
    let { menuOptions, PrefixBarButtons, SuffixBarButtons } = param;
    const dispatch = useDispatch();
    const { trackDeselectedItems } = useTrackDeselectedItems();
    const selectedItems = useSelector(selectedItemsSelector);
    const numberOfSelectedItems = selectedItems.length;
    const onClearAll = useCallback(()=>{
        trackDeselectedItems({
            fileSelectionCount: 0,
            assetSelectionCount: 0,
            boardSelectionCount: 0,
            totalSelectionCount: 0,
            trigger: "action-bar",
            type: "none"
        });
        dispatch(resetSelectedItemsAction());
    }, [
        dispatch,
        trackDeselectedItems
    ]);
    if (numberOfSelectedItems === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsx(SelectionActionBarComponent, {
        menuOptions: menuOptions,
        numberOfSelectedItems: numberOfSelectedItems,
        onClearAll: onClearAll,
        PrefixBarButtons: PrefixBarButtons,
        SuffixBarButtons: SuffixBarButtons
    });
});
BoardsAndAssetsSelectionBar.displayName = "BoardsAndAssetsSelectionBar";
